import { Injectable } from '@angular/core';
import { NotificationUser } from 'src/app/model/notification-user';
import { ApiGatewayService } from '../services/api-gateway.service';
import { ServiceObject } from 'src/app/model/service-object';
import { AppEnviroment } from 'src/app/model/app-enviroment';

@Injectable({
  providedIn: 'root'
})
export class ScreenNotificationBusinessService {

  Notifications:NotificationUser[]=[];
  
  private timer;


  constructor(private apiGatewayService: ApiGatewayService) { }

  StartNotifications()
  {
    this.GetNotifications();
    this.timer = setInterval(() => {
      this.GetNotifications().catch(x=> this.StopNotifications());
    },1000 * 60 * 5); //*5
  }

  StopNotifications()
  {
    clearInterval(this.timer);
  }

  GetNotifications(): Promise<NotificationUser[]> {
    var servObj = new ServiceObject("RoleManager", "ScreenNotification", "GetNotifications");
    servObj.Data = {userId:AppEnviroment.User.UserId};
    return this.apiGatewayService.PostAnonymousAction(servObj)
      .then(x => {
        servObj = x as ServiceObject;
        if (!servObj.Success)
          throw new Error(servObj.Message);       
        
        var result:NotificationUser[]=servObj.Data;              
        this.Notifications = result;
        return Promise.resolve(result);              
      })
      .catch(x => {
        throw x.message;
      });
  }

  CheckNotification(id:number): Promise<boolean> {
    var servObj = new ServiceObject("RoleManager", "ScreenNotification", "CheckNotification");
    servObj.Data = {id:id};
    return this.apiGatewayService.PostAction(servObj)
      .then(x => {
        servObj = x as ServiceObject;
        if (!servObj.Success)
          throw new Error(servObj.Message);
        
        this.Notifications = this.Notifications.filter(x=> { return x.Id != id  });
        
        return Promise.resolve(servObj.Data as boolean);
      })
      .catch(x => {
        throw x.message;
      });
  }
}
